(function () {
    'use strict';

    angular.module("imApp").factory("componentReplaceAblesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3739,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 3741,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
